import Reveal from "@/components/Reveal";
import { BedDouble, BedSingle, CalendarCheck, Users } from "lucide-react";

const SERVICES = [
  {
    icon: BedSingle,
    title: "Private Bedrooms",
    text: "For people who want their own bedroom in a shared home.",
  },
  {
    icon: BedDouble,
    title: "Shared Bedrooms",
    text: "For people who are comfortable renting a bed in a room with another resident.",
  },
  {
    icon: CalendarCheck,
    title: "Housing Inquiries & Tours",
    text: "Ask what's open, learn what's included, and arrange a visit.",
  },
  {
    icon: Users,
    title: "Housing Referrals",
    text: "For caseworkers and community organizations helping someone find a place to live.",
  },
];

export default function WhatWeDo() {
  return (
    <section id="what-we-do" className="py-20 sm:py-28 bg-white" data-testid="what-we-do-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">What We Do</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
            Rooms in Shared Homes, and Help Finding the Right Fit
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#5a5a5a]">
            We provide rooms in shared homes across Central Florida and help people understand their
            housing options. Here's what we offer:
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.07}>
              <article
                data-testid={`service-item-${i + 1}`}
                className="h-full bg-[#F7F7F9] border border-[#EBEBEB] rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.10)] hover:bg-white"
              >
                <span className="inline-flex w-12 h-12 rounded-2xl bg-[#EDE9E1]/60 items-center justify-center">
                  <s.icon className="w-6 h-6 text-[#E0484D]" />
                </span>
                <h3 className="mt-4 text-lg font-bold text-[#222]">{s.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#5a5a5a]">{s.text}</p>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.35}>
            <div className="h-full flex flex-col justify-center bg-[#222222] rounded-2xl p-7 text-white" data-testid="common-spaces-note">
              <h3 className="text-lg font-bold">Good to Know</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-white/70">
                Residents share common spaces such as the kitchen and living room, depending on the home.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
